import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ErrorBoundary.css';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    this.handleReset = this.handleReset.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  // Without this the fallback is terminal — the only way out was a full reload.
  handleReset() {
    this.setState({ hasError: false, error: null });
  }

  render() {
    const { hasError, error } = this.state;
    const { children, title, message } = this.props;

    if (!hasError) return children;

    return (
      <div className="error-boundary" role="alert">
        <h2 className="error-boundary__title">{title}</h2>
        <p className="error-boundary__message">{message}</p>
        {error?.message && (
          <p className="error-boundary__detail">
            <code>{error.message}</code>
          </p>
        )}
        <div className="error-boundary__actions">
          <button
            type="button"
            className="error-boundary__button"
            onClick={this.handleReset}
          >
            Try again
          </button>
          <button
            type="button"
            className="error-boundary__button error-boundary__button--secondary"
            onClick={() => window.location.reload()}
          >
            Reload page
          </button>
        </div>
      </div>
    );
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  /** Heading shown in the fallback. */
  title: PropTypes.string,
  /** Explanatory line shown under the heading. */
  message: PropTypes.string,
};

ErrorBoundary.defaultProps = {
  children: null,
  title: 'Something went wrong',
  message: 'This section failed to load. The rest of the page should still work.',
};

export default ErrorBoundary;
